import axios from '@/axios'
import helper from './helper'
import { format } from 'date-fns'

export default {
  getHomePage() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/home-page`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getAll() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getUserMedia() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/byuser?limit=500`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getByGenres(ids, excludeId, limit) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/bygenres`, {
          genreIds: ids,
          excludeId: excludeId,
          limit: limit
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getById(mediaId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/${mediaId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getByIds(mediaIds) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/ids?ids=${mediaIds}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  byMetadataId(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/by-metadata-id/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  byMetadataIds(ids) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/by-metadata-ids?ids=${ids.join(',')}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  create(media) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(media) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/media`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  // Single-field approve toggle for shortform inline UX. Backend ignores
  // every other field — safe to call from ManageMedia without sending the
  // full media payload (which would V2-reset the storage_path).
  setApproved(mediaId, approved) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/${mediaId}/set-approval`, { approved: !!approved })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },
  // Unmatched shortform uploads — files dropped in shortform watchfolders
  // that the traffic agent couldn't auto-match to a media row. Operator
  // resolves these via the Unmatched Uploads panel + Create-from-file modal.
  getUnmatchedShortformUploads(storageConfigId = null) {
    return new Promise((resolve, reject) => {
      const params = storageConfigId ? `?storage_config_id=${storageConfigId}` : ''
      axios
        .get(`/api/media/unmatched-shortform-uploads${params}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },
  // Create a media row from a no_match detection — pre-fills source link
  // from the detection, marks detection as accepted.
  createFromDetection(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/from-detection`, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },
  remove(media) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/media/${media.mediaId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  removeMultiple(ids) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/remove-multiple`, { ids: ids })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  publish(media) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/publish`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  markAsFeatured(media) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/featured`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  defaultLookups() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/default-lookups`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  importUrl(url) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/importURL`, {
          url: url
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  importMediaFile(file) {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('file', file)
      axios
        .post(`/api/media/import-media-file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  search(query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/search?q=${query}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  featured() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/featured`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  published() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/published`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getMetadataLinks() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/metadata-links`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateManualQCStatus(item) {
    return helper.post('/api/media/update-manualqcstatus', item)
  },
  async exportCsv(mediaIds = null) {
    let url = `/api/media/export/csv`
    if (mediaIds && mediaIds.length > 0) {
      url += `?mediaIds=${mediaIds.join(',')}`
    }
    const response = await axios({
      url,
      method: 'GET',
      responseType: 'blob'
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink = document.createElement('a')

    const filename = mediaIds && mediaIds.length > 0
      ? `selected-media-${format(new Date(), 'ddMMyy')}.csv`
      : `all-media-${format(new Date(), 'ddMMyy')}.csv`
    fileLink.href = fileURL
    fileLink.setAttribute('download', filename)
    document.body.appendChild(fileLink)

    fileLink.click()
  },
  async exportExcel(mediaIds = null) {
    let url = `/api/media/export/excel`
    if (mediaIds && mediaIds.length > 0) {
      url += `?mediaIds=${mediaIds.join(',')}`
    }
    const response = await axios({
      url,
      method: 'GET',
      responseType: 'blob'
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink = document.createElement('a')

    const filename = mediaIds && mediaIds.length > 0
      ? `selected-media-${format(new Date(), 'ddMMyy')}.xlsx`
      : `all-media-${format(new Date(), 'ddMMyy')}.xlsx`
    fileLink.href = fileURL
    fileLink.setAttribute('download', filename)
    document.body.appendChild(fileLink)

    fileLink.click()
  },

  // Link source file to non-episodic media
  linkSourceFile(mediaId, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/${mediaId}/link-source`, data)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },

  // Unlink source file from media
  unlinkSourceFile(mediaId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/media/${mediaId}/link-source`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },

  // Get QC status for media
  getQcStatus(mediaId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/${mediaId}/qc-status`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },

  // Submit QC job for media
  submitQcJob(mediaId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/${mediaId}/submit-qc`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },

  // Override QC failure
  overrideQc(mediaId, reason) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/${mediaId}/override-qc`, { reason })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },

  // Download import template
  async downloadImportTemplate() {
    const response = await axios({
      url: `/api/media/import-template`,
      method: 'GET',
      responseType: 'blob'
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink = document.createElement('a')

    fileLink.href = fileURL
    fileLink.setAttribute('download', 'BMS_Batch_Import_Template_v2.1.xlsx')
    document.body.appendChild(fileLink)

    fileLink.click()
    document.body.removeChild(fileLink)
  },

  // Generate TX filename preview based on channel template configuration
  // For non-series media types: movies, tvc, filler, promo, gfx
  generateTxFilenamePreview(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/generate-tx-filename`, data)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  }
}
